export default __webpack_public_path__ + "static/media/Pilgrim's Legguards of the Soaring God.6d266026.jpg";